var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { AwsUi } from '../../../../core/runtime/src';
import { sortByPriority } from '../plugins/helpers/utils';
export function handleDrawerRegistration(component, drawers) {
    if (!component.__drawerWasActive) {
        var defaultActiveDrawer = sortByPriority(drawers).find(function (drawer) { return drawer.defaultActive; });
        if (defaultActiveDrawer) {
            component.__activeDrawerId = defaultActiveDrawer.id;
        }
    }
    component.__drawers = convertRuntimeDrawers(drawers);
}
function convertRuntimeDrawers(drawers) {
    var converted = drawers.map(function (_a) {
        var mountContent = _a.mountContent, unmountContent = _a.unmountContent, runtimeDrawer = __rest(_a, ["mountContent", "unmountContent"]);
        return (__assign(__assign({}, runtimeDrawer), { trigger: {
                iconSvg: runtimeDrawer.trigger.iconSvg
            }, content: (AwsUi.__createElement("div", { lifecycleKey: runtimeDrawer.id, componentDidMount: function (element) { return mountContent(element); }, componentWillUnmount: function (element) { return unmountContent(element); } })) }));
    });
    converted.sort(function (a, b) {
        var _a, _b;
        if (b.orderPriority !== a.orderPriority) {
            return Math.sign((_a = b.orderPriority, (_a !== null && _a !== void 0 ? _a : 0)) - (_b = a.orderPriority, (_b !== null && _b !== void 0 ? _b : 0)));
        }
        return b.id < a.id ? 1 : -1;
    });
    return converted;
}
//# sourceMappingURL=utils.js.map